import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";
import { EMAIL_TEMPLATE_CONTROLLER } from "api/Service";

export const useEmailTemplates = (patientId) => {
  const tenantVal = localStorage.getItem("kinesin-tenant");

  return useQuery({
    queryKey: ["emailTemplatesAll", tenantVal, patientId],
    queryFn: async () => {
      const axiosInstance = createAxiosInstance();
      const url = patientId
        ? `${tenantVal}${EMAIL_TEMPLATE_CONTROLLER}?patientId=${patientId}`
        : `${tenantVal}${EMAIL_TEMPLATE_CONTROLLER}`;
      const response = await axiosInstance.get(url);

      return response.data || [];
    },
    staleTime: 5 * 60 * 1000,
  });
};
